// The business entity spaces, from the outermost to the innermost.
export enum SpaceLevel {
  Folder = 0,
  Mission = 1,
}
